<div class="title-container">
  @if (icon) {
    <mat-icon [svgIcon]="icon" [style.color]="iconColor"></mat-icon>
  }
  <label>{{ name }}</label>
</div>

<div class="right-container">
  @if (view === ListViewOptions.Table) {
    <oph-icon
      class="view-icon"
      (click)="onView(ListViewOptions.Grid)"
      [name]="'list-views/grid-view'"
      [size]="27"
    ></oph-icon>
  }
  @if (view === ListViewOptions.Grid) {
    <oph-icon
      class="view-icon"
      (click)="onView(ListViewOptions.Table)"
      [name]="'list-views/table-view'"
      [size]="27"
    ></oph-icon>
  }

  @if (showProjectSelector) {
    <project-selector
      [selectedProject]="selectedProject"
      [loadingProject]="projectSelectorLoading"
      [hideActionButton]="true"
      [buttonStyle]="{
        'font-size': '14px',
        height: '34px',
        padding: '0',
        gap: '8px',
        'min-width': '126px',
        fontWeight: '400'
      }"
      [hostStyle]="{height: '34px', background: 'white', width: '200px'}"
    >
      <ng-container class="project-selector">
        <button
          class="oph-select-menu-item"
          [class.selected]="selectedProject === null"
          (click)="onSelectProject(null)"
        >
          <div class="menu-item-container">
            <div class="project-color" style="background-color: #e5e3dc"></div>
            <span class="project-display">All Projects</span>
          </div>
        </button>
        @for (project of projects; track $index) {
          <project-selector-menu-project-button
            [project]="project"
            [isSelected]="project?.label === selectedProject?.label"
            (buttonClick)="onSelectProject(project)"
          ></project-selector-menu-project-button>
        }
      </ng-container>
    </project-selector>
  }

  @if (!hideSearch) {
    <div class="input-container">
      <oph-icon [name]="'list-views/search'" [size]="22"></oph-icon>
      <input placeholder="Search" [value]="searchValue" (input)="onSearch($any($event.target).value)" />
    </div>
  }

  <oph-button
    color="green"
    (buttonClick)="onCreateNew()"
    [style]="{'font-size': '14px', height: '34px', padding: '0 10px', gap: '8px', 'min-width': '126px'}"
    [loading]="loadingCreateNew"
    [disabled]="loadingCreateNew"
  >
    <mat-icon svgIcon="plus" class="plus-icon"></mat-icon>
    {{ createButtonText || 'Create new' }}
  </oph-button>
</div>
